'use client'
import { useState } from 'react'

import { consorcios, consorciosEstados } from '@/components/Form/Form.data'
import { usePartner } from '@/hooks'
import { useParams } from 'next/navigation'

const estados = Object.keys(consorcios) as consorciosEstados[]

const Simulador = () => {
  const [estado, setEstado] = useState('')
  const [valorConta, setValorConta] = useState('R$ 0,00')
  const [erro, setErro] = useState('')
  const [mostrarSimulador, setMostrarSimulador] = useState(false)
  const { slug } = useParams()
  const { partner } = usePartner(slug as string)

  const [resultado, setResultado] = useState({
    economiaMensal: 0,
    economiaAnual: 0,
    co2: 0,
    arvores: 0
  })

  const calcular = () => {
    if (!estado || !valorConta) {
      setErro('Preencha todos os campos.')
      return
    }

    const conta = parseFloat(valorConta.replace(/\D/g, '')) / 100
    if (isNaN(conta) || conta <= 0) {
      setErro('Informe um valor válido.')
      return
    }

    const descontoStr =
      partner?.id !== '' && partner.descontoOfertado
        ? partner.descontoOfertado
        : (consorcios[estado as consorciosEstados]?.desconto_padrao ?? '0%')

    const desconto = parseFloat(descontoStr.replace('%', '')) / 100
    setErro('')

    const economiaMensal = conta * desconto
    const economiaAnual = economiaMensal * 12
    const co2 = (conta / 950) * 0.0545
    const arvores = co2 * 7.14

    setResultado({ economiaMensal, economiaAnual, co2, arvores })
  }

  return (
    <div className="fixed bottom-6 right-6 z-50 w-full max-w-sm">
      {!mostrarSimulador ? (
        <button
          onClick={() => setMostrarSimulador(true)}
          className="text-md fixed bottom-6 right-6 z-40 rounded bg-amber-400 px-6 py-3 font-bold text-teal-900 shadow-lg transition hover:bg-amber-500 hover:text-teal-900 lg:px-10 lg:py-3 lg:text-lg"
        >
          CALCULE SEU DESCONTO
        </button>
      ) : (
        <div className="rounded-xl bg-white p-6 shadow-xl">
          <div className="flex items-center justify-between">
            <h2 className="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-800">
              Simule sua economia
            </h2>
            <button
              onClick={() => setMostrarSimulador(false)}
              className="text-gray-500 hover:text-gray-800"
            >
              ✕
            </button>
          </div>

          {/* Inputs lado a lado */}
          <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-end">
            <div className="flex-1">
              <label className="mb-1 block font-medium">Valor da conta</label>
              <input
                type="text"
                value={valorConta}
                onChange={(e) => {
                  const raw = e.target.value.replace(/\D/g, '')
                  const formatted = new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2
                  }).format(Number(raw) / 100)
                  setValorConta(formatted)
                }}
                className="w-full rounded border p-2"
              />
            </div>

            <div className="flex-1">
              <label className="mb-1 block font-medium">Estado</label>
              <select
                value={estado}
                onChange={(e) => setEstado(e.target.value)}
                className="w-full rounded border p-2"
                style={{ height: '42.5px' }}
              >
                <option value="">Selecione</option>
                {estados.map((uf) => (
                  <option key={uf} value={uf}>
                    {uf}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {erro && <p className="mb-2 text-sm font-medium text-red-600">{erro}</p>}

          <button
            onClick={calcular}
            className="w-full rounded bg-green-600 py-2 text-white transition hover:bg-green-700"
          >
            Calcular
          </button>

          {resultado.economiaAnual > 0 && (
            <>
              <hr className="my-4" />
              <div className="grid grid-cols-2 gap-4 text-center text-sm">
                <div>
                  <p className="text-gray-500">Economia anual:</p>
                  <p className="text-lg font-bold text-green-600">
                    R${' '}
                    {resultado.economiaAnual.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                  </p>
                </div>
                <div>
                  <p className="text-gray-500">Economia mensal:</p>
                  <p className="text-lg font-semibold text-green-500">
                    R${' '}
                    {resultado.economiaMensal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default Simulador
